import request from '../../axios/axiosconfig.js'

export function getAllPendingApproval(params) {
  return request({
    url: '/ps/pendingApproval/getAllPendingApproval',
    method: 'get',
    params: params
  })
}
export function exportPage(params) {
  return request({
    url: '/ps/pendingApproval/exportPage',
    method: 'get',
    params: params
  })
}
export function exportAll(params) {
  return request({
    url: '/ps/pendingApproval/exportAll',
    method: 'get',
    params: params
  })
}
export function getPendingApprovalById(params,id) {
  return request({
    url: '/ps/pendingApproval/getPendingApprovalById/'+params+'/'+id,
    method: 'get'
  })
}
export function approval(data) {
  return request({
    url: '/ps/pendingApproval/approval',
    method: 'post',
    data: data
  })
}
export function refuseWithdraw(data) {
  return request({
    url: '/ps/pendingApproval/refuseWithdraw',
    method: 'post',
    data: data
  })
}
export function transfer(data) {
  return request({
    url: '/ps/pendingApproval/transfer',
    method: 'post',
    data: data
  })
}
export function confirmTransfer(data) {
  return request({
    url: '/ps/pendingApproval/transferDone',
    method: 'post',
    data: data
  })
}
export function transferFail(data) {
  return request({
    url: '/ps/pendingApproval/transferFail',
    method: 'post',
    data: data
  })
}

export function modifyBankCard(data) {
  return request({
    url: '/ps/pendingApproval/modifyBankCard',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/withdraw/withdrawapply.js